/*
 * @Author: 刑天
 * @Date: 2022-05-13 11:21:57
 * @LastEditTime: 2022-09-07 09:56:45
 * @Description: 战神
 */
import request from '@/utils/request';

//会员等级
export function getMemberLevel() {
  return request('/config/queryLevels', {
    method: 'GET',
    // params: values,
  });
}
//新增活动设置
export function addActivityBooking(values) {
  return request('/activityBooking/addActivityBooking', {
    method: 'POST',
    data: values,
  });
}
//更新活动设置
export function updateActivityBooking(values) {
  return request('/activityBooking/updateActivityBooking', {
    method: 'POST',
    data: values,
  });
}
//查询详情
export function getDetail(values) {
  return request('/activityBooking/queryOne', {
    method: 'POST',
    data: values,
  });
}

//新增和更新活动列表分享小程序卡片
export function createAndUpdateListCard(values) {
  return request('/activityBooking/createAndUpdateListCard', {
    method: 'POST',
    data: values,
  });
}
//获取活动列表分享小程序卡片信息
export function getCardList(values) {
  return request('/activityBooking/queryListCardWeb', {
    method: 'POST',
    data: values,
  });
}
